import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Credentials } from "auth";
import { State } from "redux/state";

export type DeleteCMSToken = "DELETE_CMS_TOKEN";
export const DELETE_CMS_TOKEN: DeleteCMSToken = "DELETE_CMS_TOKEN";
export type DeleteCMSTokenEnd = "DELETE_CMS_TOKEN_END";
export const DELETE_CMS_TOKEN_END: DeleteCMSTokenEnd = "DELETE_CMS_TOKEN_END";

export interface DeleteCMSTokenAction extends Action {
    payload: {
        appId: string;
        credentials: Credentials;
        tokenId: string;
    };
    type: DeleteCMSToken;
}

export interface DeleteCMSTokenEndAction extends Action {
    payload: {
        appId: string;
        tokenId?: string;
        error?: Error;
    };
    type: DeleteCMSTokenEnd;
}

export function deleteCMSToken(
    appId: string,
    tokenId: string
): ThunkAction<void, State, undefined, DeleteCMSTokenAction> {
    return (dispatch: Dispatch<DeleteCMSTokenAction>, getState) => {
        const { credentials } = getState().auth;

        dispatch(deleteCMSTokenWithCredentials(appId, tokenId, credentials));
    };
}

function deleteCMSTokenWithCredentials(appId: string, tokenId: string, credentials: Credentials): DeleteCMSTokenAction {
    return {
        payload: {
            appId,
            credentials,
            tokenId
        },
        type: DELETE_CMS_TOKEN
    };
}

export function deleteCMSTokenEnd(appId: string, error?: Error, tokenId?: string): DeleteCMSTokenEndAction {
    return {
        payload: { appId, error, tokenId },
        type: DELETE_CMS_TOKEN_END
    };
}
